// import Swiper bundle with all modules installed
import Swiper from "swiper/bundle";

// import styles bundle
import "swiper/css/bundle";

class VideoSwiper {
  constructor(container) {
    this.container = container;
    this.navigation = {
      desktop: {
        nextEl: ".video-carousel__header-navigation .video-next",
        prevEl: ".video-carousel__header-navigation .video-prev",
      },
      mobile: {
        nextEl: ".video-carousel__footer-navigation .video-next",
        prevEl: ".video-carousel__footer-navigation .video-prev",
      },
    };
  }

  addListenders(instance) {
    // on Load
    window.addEventListener("load", function () {
      instance.swiperMode();
    });

    // on Resize
    window.addEventListener("resize", function () {
      instance.swiperMode();
    });
  }

  swiperMode() {
    if (typeof this.swiper?.destroy === "function")
      this.swiper.destroy(false, true); // clean styles only

    // Enable (for mobile)
    if (window.squiz.breakpoints.sm.matches) {
      this.swiper = new Swiper(this.container, {
        // Optional parameters
        a11y: true,
        loop: false,
        grabCursor: true,
        slidesPerView: 1.05,
        direction: "horizontal",
        navigation: this.navigation.mobile,
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
        },
      });
    } else if (
      window.squiz.breakpoints.md.matches ||
      window.squiz.breakpoints.lg.matches ||
      window.squiz.breakpoints.xl.matches
    ) {
      this.swiper = new Swiper(this.container, {
        // Optional parameters
        a11y: true,
        loop: false,
        grabCursor: true,
        slidesPerView: 1.025,
        direction: "horizontal",
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
        },
        navigation: this.navigation.desktop,
      });
    } else {
      this.swiper = new Swiper(this.container, {
        // Optional parameters
        loop: false,
        grabCursor: true,
        slidesPerView: 1.5,
        direction: "horizontal",
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
        },
        navigation: this.navigation.desktop,
      });
    }

    this.swiper.on("slideChange", function () {
      // pause all videos
      if (VidsController) {
        VidsController.pauseAllVideos();
        VidsController.closeAllTranscripts();
      }
    });
  }
}

// check and init swiper
var container = ".video-articles__container .swiper-container";
if (document.querySelector(container)) {
  const VideoSwipe = new VideoSwiper(container);
  VideoSwipe.addListenders(VideoSwipe);
}

export class YTPlayer {
  player;
  firstRun;
  constructor(videoId, video, control) {
    this.firstRun = true;

    // eslint-disable-next-line no-undef
    this.player = new YT.Player(videoId, {
      width: 560,
      height: 315,
      videoId: videoId,
      playerVars: { controls: 0, cc_load_policy: 1 },
      events: {
        onReady: (event) => {
          event.target.playVideo();
        },
        // eslint-disable-next-line no-unused-vars
        onStateChange: (event) => {
          //https://developers.google.com/youtube/iframe_api_reference
          /* -1 – not iniciated
            0 – Ended
            1 – Playing
            2 – Paused
            3 – Buffering
            5 – Cued
            */

          var play = control.querySelector(".play");
          var pause = control.querySelector(".pause");
          var cover = video.querySelector("[data-article-video-image]");
          var playerContainer = video.querySelector(".video-container");

          switch (this.player.getPlayerState()) {
            // when the current video starts playing, remove the cover image and toggle the icon classes for display
            // case -1:
            case 3:
            case 1:
              // remove the cover image, we don't need it
              try {
                // alert(this.player.getPlayerState());
                if (pause) pause.classList.remove("hidden");
                if (play) play.classList.add("hidden");
                if (cover && !cover.classList.contains("hidden"))
                  cover.classList.add("hidden");
                if (
                  playerContainer &&
                  playerContainer.classList.contains("hidden")
                )
                playerContainer.classList.remove("hidden");
              } catch (e) {
                console.log(e);
              }
              
              break;
              // when the current video, paused or stopped triggered then toggle the icon classes
              case 5:
                case 2:
                  case -1:
                  try {
                // alert(this.player.getPlayerState());
                if (pause) pause.classList.add("hidden");
                if (play) play.classList.remove("hidden");
                if (cover && cover.classList.contains("hidden"))
                  cover.classList.remove("hidden");
                if (
                  playerContainer &&
                  !playerContainer.classList.contains("hidden")
                )
                  playerContainer.classList.add("hidden");
              } catch (e) {
                console.log(e);
              }

              break;
          }
        },
      },
    });
  }
}

class VideoController {
  players;
  transcript = {
    openTitle: "Read Transcript",
    closeTitle: "Close Transcript",
  };
  constructor(selector) {
    this.players = [];
    var tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    this.videoItems = document.querySelectorAll(selector);
    if (this.videoItems) {
      this.videoItems.forEach((video) => {
        // bind play and pause controls
        this.bindVideoControls(video);
        this.bindTranscriptControls(video);
      });
    }
  }

  pauseAllVideos() {
    if (this.players.length) {
      this.players.forEach((p) => {
        p.player.player.pauseVideo();
      });
    }
  }

  closeAllTranscripts() {
    this.videoItems.forEach((video) => {
      var transcript = video.querySelector(
        ".video-article__transcript-container.open"
      );
      var control = video.querySelector(
        ".video-article__description--transcript-button"
      );
      if (transcript) {
        transcript.classList.remove("open");
      }
      if (control) {
        control.innerHTML = this.transcript.openTitle;
        control.setAttribute("aria-expanded", false);
      }
    });
  }

  bindTranscriptControls(video) {
    var controls = video.querySelectorAll(
      ".video-article__description--transcript-button"
    );
    var self = this;
    if (controls) {
      controls.forEach((control) => {
        // eslint-disable-next-line no-unused-vars
        control.addEventListener("click", (e) => {
          self.toggleTranscriptControl(video, control);
        });
      });
    }
  }

  toggleTranscriptControl(video, control) {
    var transcript = video.querySelector(
      ".video-article__transcript-container"
    );
    if (transcript) {
      if (transcript.classList.contains("open")) {
        control.innerHTML = this.transcript.openTitle;
        control.setAttribute("aria-expanded", false);
        transcript.classList.remove("open");
      } else {
        transcript.classList.add("open");
        control.setAttribute("aria-expanded", true);
        control.innerHTML = this.transcript.closeTitle;
      }
    }
  }

  bindVideoControls(video) {
    var controls = video.querySelectorAll(".icon-video-control");
    var self = this;
    if (controls) {
      controls.forEach((control) => {
        // eslint-disable-next-line no-unused-vars
        control.addEventListener("click", (e) => {
          self.toggleVideoControl(video, control);
        });
      });
    }
  }

  toggleVideoControl(video, control) {
    var videoId = video.getAttribute("data-video-id");
    // video is paused or initial state
    if (videoId) {
      var current = this.players.find((e) => e.id === videoId);
      if (!current) {
        current = {
          id: videoId,
          player: new YTPlayer(videoId, video, control),
        };
        this.players.push(current);
        control.setAttribute("aria-label", "Pause");
      } else {
        var state = current.player.player.getPlayerState();
        switch (state) {
          // if the current video is paused, stoped or endded then player
          case -1:
          case 0:
          case 5:
          case 2:
            current.player.player.playVideo();
            control.setAttribute("aria-label", "Pause");
            break;
          // if the currrent video is playing then pause
          case 1:
            current.player.player.pauseVideo();
            control.setAttribute("aria-label", "Play");
            break;
        }
      }
    }
  }
}

// init all videos
const VidsController = new VideoController(".video-articles__item");
